import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework'
import React, { ReactNode } from 'react'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    highlighted: {
      backgroundColor: 'rgba(0, 161, 255, 0.18)',
      borderRadius: '4px',
      margin: theme.spacing(0, -2),
      padding: theme.spacing(2),
    },
  })
)

const HighlightedSection = React.forwardRef(
  (props: { highlighted: boolean; children: ReactNode[] | ReactNode }, ref) => {
    const classes = useStyles()

    return (
      <div ref={ref as any} className={props.highlighted ? classes.highlighted : undefined}>
        {props.children}
      </div>
    )
  }
)

export default HighlightedSection
